import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Notificar } from "../../Comunes/Notificador";

function ModificarMotivoLiquidacionModal({
  motivoLiquidacion,
  actualizarMotivoLiquidacion,
  cargarMotivos,
}) {
  const [show, setShow] = useState(false);
  const [motivoLiquidacionLocal, setMotivoLiquidacionLocal] =
    useState(motivoLiquidacion);
  const motivosQueRequierenOperacionNueva = [3, 14];

  const motivos = !cargarMotivos
    ? []
    : cargarMotivos.filter((x) => x.codigo !== 30);

  const handleClose = () => {
    setMotivoLiquidacionLocal(motivoLiquidacion);
    setShow(false);
  };

  const handleShow = () => setShow(true);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!datosValidos()) {
      return;
    }

    if (
      !motivosQueRequierenOperacionNueva.includes(
        motivoLiquidacionLocal.motivoLiquidacionPropuesto.codigo
      )
    ) {
      motivoLiquidacionLocal.operacionNueva = null;
    }

    actualizarMotivoLiquidacion(motivoLiquidacionLocal);
    handleClose();
  };

  function datosValidos() {
    if (motivoLiquidacionLocal.motivoLiquidacionPropuesto?.codigo === null) {
      Notificar("error", "Debe seleccionar un motivo de liquidación.");
      return false;
    }

    if (
      Number(motivoLiquidacionLocal.motivoLiquidacionPropuesto?.codigo) ===
      Number(motivoLiquidacionLocal.motivoLiquidacionReportado.codigo)
    ) {
      Notificar(
        "error",
        "El motivo de liquidación propuesto es el mismo motivo de liquidación reportado por la SUGEF."
      );
      return false;
    }

    if (
      motivosQueRequierenOperacionNueva.includes(
        motivoLiquidacionLocal.motivoLiquidacionPropuesto.codigo
      ) &&
      !motivoLiquidacionLocal.operacionNueva
    ) {
      Notificar("error", "La operación nueva es obligatoria.");
      return false;
    }

    return true;
  }

  return (
    <>
      <button
        className="btn btn-primary btn-sm"
        title="Modificar motivo de liqidación"
        onClick={handleShow}
      >
        <i className="fas fa-edit"></i>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Modificar Motivo de Liquidación</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <div className="form-group">
              <label htmlFor="MotivoPropuesto">
                Motivo de Liquidación Propuesto
              </label>

              <select
                id="MotivoPropuesto"
                className="form-control"
                name="MotivoPropuesto"
                value={
                  motivoLiquidacionLocal.motivoLiquidacionPropuesto?.codigo ??
                  "-1"
                }
                onChange={(e) => {
                  setMotivoLiquidacionLocal({
                    ...motivoLiquidacionLocal,
                    motivoLiquidacionPropuesto: {
                      codigo: Number(e.target.value),
                      descripcionLarga: e.target.selectedOptions[0].text,
                    },
                  });
                }}
              >
                <option key="-1" value="-1" disabled>
                  [Motivo Liquidación]
                </option>
                {motivos.map((item) => (
                  <option key={item.codigo} value={item.codigo}>
                    {item.descripcionLarga}
                  </option>
                ))}
              </select>
            </div>

            {motivosQueRequierenOperacionNueva.includes(
              motivoLiquidacionLocal.motivoLiquidacionPropuesto.codigo
            ) ? (
              <div className="form-row">
                <div className="form-group col">
                  <label htmlFor="operacionNueva">Operación Nueva</label>
                  <Form.Control
                    className="form-control"
                    name="operacionNueva"
                    id="operacionNueva"
                    value={motivoLiquidacionLocal.operacionNueva ?? ""}
                    onChange={(e) =>
                      setMotivoLiquidacionLocal({
                        ...motivoLiquidacionLocal,
                        operacionNueva: e.target.value.toUpperCase().trim(),
                      })
                    }
                  />
                </div>
              </div>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Confirmar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default ModificarMotivoLiquidacionModal;
